<template>
  <Draggable
    ghostClass="dragging-row"
    tag="tbody"
    :list="data.data"
    @change="onChange"
    :options="{ animation: 200 }"
    handle=".drag-handle"
    :disabled="isUpdating"
  >
    <slot></slot>
  </Draggable>
</template>
<script>
import Draggable from "vuedraggable";
import apiClient from "@/services/axios";

export default {
  components: {
    Draggable,
  },
  inject: ["data"],
  data() {
    return {
      isUpdating: false,
    };
  },
  methods: {
    handleApiError(error, defaultMessage) {
      // Check for PACK_PERMISSION_ERROR
      if (
        error.response?.data?.errorCode === "PACK_PERMISSION_ERROR" ||
        error.response?.data?.error?.errorCode === "PACK_PERMISSION_ERROR"
      ) {
        this.$message.error(this.$t("errorCode.PACK_PERMISSION_ERROR"));
        return;
      }
      // Fallback to default error message
      this.$message.error(
        error.response?.data?.message || defaultMessage || this.$t("error.erreur")
      );
    },
    async onChange(evt) {
      // If no actual change happened, return early
      if (!evt.moved || this.isUpdating) return;

      this.isUpdating = true;

      const updates = this.data.data.map((item, index) => ({
        _id: item._id,
        order: index,
      }));

      try {
        await apiClient.put("/bulletin/v2/module/update-orders", {
          data: updates,
        });
        // Update the orders in local data
        this.data.data = this.data.data.map((item, index) => ({
          ...item,
          order: index,
        }));
        this.$message.success(this.$t("success.moduleOrderUpdated"));
      } catch (error) {
        this.handleApiError(error, this.$t("error.failedToUpdateModuleOrder"));
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>
